/**
 * Split backlink cell badges by owner.
 *
 * Referring page (`url_from`): lost / new / home — page identity, not rel= of the <a>.
 * Link URL (`url_to`): UGC, sponsored, nofollow, broken, image, … — the href.
 * Redirect is not a badge: yellow lock + destination under the same cell.
 */

export const isFlagOn = (value: unknown): boolean =>
  value === true || value === 1 || value === '1' || value === 'true';

export const BEST_LINK_TOOLTIP =
  'معیارهای لینک بهترین: دامین اتوریتی Moz حداقل ۲۰ یا Domain Rating طبق Ahrefs حداقل ۴۰؛ dofollow فعال؛ کمتر از ۲۰۰ لینک خارجی در صفحه؛ صفحه ارجاع غیرمستقیم نیست؛ noindex نیست؛ nofollow نیست؛ canonical متفاوت نیست؛ لینک در متن صفحه است.';

export const HOME_PAGE_TOOLTIP =
  'این بک‌لینک از صفحه اصلی (خانه) دامنه ارجاع‌دهنده ایجاد شده است؛ یعنی صفحه ارجاع همان صفحه اصلی سایت است.';

export const PAGE_LANGUAGE_TOOLTIP =
  'زبان شناسایی‌شده برای محتوای صفحه ارجاع‌دهنده.';

export const PAGE_STATUS_TOOLTIP =
  'صفحه ارجاع‌دهنده با این کد وضعیت HTTP پاسخ داده است.';

export const PAGE_UNAVAILABLE_TOOLTIP =
  'دامنه به‌صورت موقت یا دائم قابل دسترس نیست (خطای DNS). ممکن است منقضی شده باشد، تنظیماتش مشکل داشته باشد یا سایت دچار قطعی موقت باشد. اگر در بررسی‌های بعدی هم ادامه داشت، احتمال از بین رفتن بک‌لینک بیشتر است.';

export const LAST_MODIFIED_TOOLTIP =
  'مدت زمان از آخرین بروزرسانی صفحه که توسط خزنده میزفا تولز ثبت شده.';

export const NOINDEX_TOOLTIP =
  'صفحه ارجاع‌دهنده دارای robots=noindex است و به موتورهای جست‌وجو اعلام می‌کند صفحه را ایندکس نکنند.';

export const CANONICAL_DIFFERENT_TOOLTIP =
  'نشانی canonical صفحه ارجاع‌دهنده با نشانی خود صفحه متفاوت است.';

export const NEW_LINK_TOOLTIP =
  'خزنده میزفا تولز این لینک را تازه پیدا کرده است؛ این نشان به معنی تازه ساخته شدن لینک نیست.';

export const MOZ_GROUP_TOOLTIP =
  'معیارهای MOZ و Ahrefs شامل دامین اتوریتی (DA)، اسپم اسکور (SS) و Domain Rating (DR) است.';

export const MOZ_DA_TOOLTIP =
  'DA مخفف Domain Authority است و اعتبار دامنه را نشان می‌دهد.';

export const MOZ_SS_TOOLTIP =
  'SS مخفف Spam Score است و میزان احتمال اسپم بودن دامنه را نشان می‌دهد.';

export const AHREFS_DR_TOOLTIP =
  'DR مخفف Domain Rating است و قدرت پروفایل بک‌لینک دامنه را طبق Ahrefs نشان می‌دهد.';

export const LINK_GROUP_TOOLTIP =
  'این گروه اطلاعات لینک ساخته‌شده در صفحه ارجاع را نشان می‌دهد.';

export const LINK_HREF_TOOLTIP =
  'نشانی مقصدی که لینک ساخته‌شده به آن اشاره می‌کند؛ href همان آدرس لینک در HTML است.';

export const SEMANTIC_LOCATION_TOOLTIP =
  'این لینک داخل این عنصر HTML معنایی در صفحه ارجاع ایجاد شده است؛ این برچسب جایگاه لینک را در ساختار صفحه نشان می‌دهد.';

export const LINK_ANCHOR_TOOLTIP =
  'متن قابل مشاهده لینک؛ در صورت وجود، قطعه‌متن‌های اطراف لینک نیز در این ستون نمایش داده می‌شوند.';

export const REL_GROUP_TOOLTIP =
  'این گروه ویژگی‌های rel و وضعیت follow لینک را نشان می‌دهد.';

export const REL_DOFOLLOW_TOOLTIP =
  'لینک follow است؛ یعنی rel=nofollow ندارد یا مقدار dofollow آن true است.';

export const REL_EXTERNAL_TOOLTIP =
  'این لینک با rel=external علامت‌گذاری شده و به دامنه‌ای خارج از دامنه سایت اشاره می‌کند.';

export const REL_UGC_TOOLTIP =
  'این لینک با rel=ugc علامت‌گذاری شده است؛ یعنی لینک مربوط به محتوای تولیدشده توسط کاربر است.';

export const REL_ALTERNATE_TOOLTIP =
  'این لینک با rel=alternate علامت‌گذاری شده و به نسخه جایگزین محتوا اشاره می‌کند.';

export const REL_NOOPENER_TOOLTIP =
  'این لینک rel=noopener دارد؛ صفحه مقصد به پنجره‌ای که لینک را باز کرده دسترسی ندارد.';

export const REL_NOREFERRER_TOOLTIP =
  'این لینک rel=noreferrer دارد؛ اطلاعات صفحه ارجاع‌دهنده برای مقصد ارسال نمی‌شود.';

export const MOZ_SPAM_SCORE_TOOLTIP =
  'این امتیاز توسط Moz محاسبه می‌شود و مربوط به کل دامنه است، نه یک صفحه خاص.\nمحدوده 0٪ تا 30٪: اسپم اسکور پایین\nمحدوده 31٪ تا 60٪: اسپم اسکور متوسط با برچسب نارنجی (دامنه اسپم)\nمحدوده 61٪ تا 100٪: اسپم اسکور بالا با برچسب قرمز (دامنه اسپم)';

export const BACKLINK_SPAM_SCORE_TOOLTIP =
  'این امتیاز توسط میزفا تولز محاسبه می‌شود و مربوط به لینک و صفحه ارجاع است.\nمحدوده 0٪ تا 30٪: اسپم اسکور پایین\nمحدوده 31٪ تا 60٪: اسپم اسکور متوسط با برچسب نارنجی (لینک اسپم)\nمحدوده 61٪ تا 100٪: اسپم اسکور بالا با برچسب قرمز (لینک اسپم)';

export const hasRedirectTarget = value =>
  typeof value === 'string' && value.trim() !== '' && value !== 'null';

export const isRedirectedUrl = (target, isIndirect) =>
  hasRedirectTarget(target) || isFlagOn(isIndirect);

export const attributeList = attributes => {
  if (Array.isArray(attributes)) {
    return attributes.map(item => String(item).toLowerCase());
  }
  if (typeof attributes === 'string' && attributes.trim()) {
    return attributes
      .replace(/[[\]]/g, '')
      .split(/[\s,]+/)
      .map(item => item.toLowerCase())
      .filter(Boolean);
  }
  return [];
};

export const displayUrlWithoutScheme = url =>
  String(url || '').replace(/^https?:\/\//i, '');

const mozSpamScoreBadge = data => {
  if (isFlagOn(data?.moz_spam_score_high)) {
    return {
      show: true,
      label: 'دامنه اسپم',
      color: 'danger',
      attention: true,
      tooltip: MOZ_SPAM_SCORE_TOOLTIP
    };
  }
  if (isFlagOn(data?.moz_spam_score_medium)) {
    return {
      show: true,
      label: 'دامنه اسپم',
      color: 'warning',
      attention: true,
      tooltip: MOZ_SPAM_SCORE_TOOLTIP
    };
  }

  return {
    show: false,
    label: 'دامنه اسپم',
    color: 'warning',
    tooltip: MOZ_SPAM_SCORE_TOOLTIP
  };
};

const backlinkSpamScoreBadge = data => {
  if (isFlagOn(data?.backlink_spam_score_high)) {
    return {
      show: true,
      label: 'لینک اسپم',
      color: 'danger',
      attention: true,
      tooltip: BACKLINK_SPAM_SCORE_TOOLTIP
    };
  }
  if (isFlagOn(data?.backlink_spam_score_medium)) {
    return {
      show: true,
      label: 'لینک اسپم',
      color: 'warning',
      attention: true,
      tooltip: BACKLINK_SPAM_SCORE_TOOLTIP
    };
  }

  return {
    show: false,
    label: 'لینک اسپم',
    color: 'warning',
    tooltip: BACKLINK_SPAM_SCORE_TOOLTIP
  };
};

const getPageLanguageBadge = data => {
  const language =
    typeof data?.page_from_language === 'string'
      ? data.page_from_language.trim()
      : '';

  return {
    show: Boolean(language),
    label: language ? language.toUpperCase() : 'زبان',
    color: 'secondary',
    compact: true,
    tooltip: PAGE_LANGUAGE_TOOLTIP
  };
};

const getPageStatusBadge = data => {
  const status = Number(data?.page_from_status_code);
  const isUnavailable = status === 530;
  const show = isUnavailable || status === 404 || status === 410;

  return {
    show,
    label: isUnavailable ? 'عدم دسترسی' : show ? String(status) : '',
    color: 'danger',
    icon: isUnavailable ? 'plug-circle-xmark' : undefined,
    tooltip: isUnavailable ? PAGE_UNAVAILABLE_TOOLTIP : PAGE_STATUS_TOOLTIP
  };
};

const getLastModifiedBadge = data => {
  const rawAgeDays = data?.last_modified_utc_age_days;
  const ageDays = Number(rawAgeDays);
  if (rawAgeDays == null || !Number.isInteger(ageDays) || ageDays < 0) {
    return {
      show: false,
      label: '',
      color: 'secondary',
      tooltip: LAST_MODIFIED_TOOLTIP
    };
  }

  let label = 'امروز';
  if (ageDays === 1) label = 'دیروز';
  else if (ageDays >= 2 && ageDays < 7) label = `${ageDays} روز پیش`;
  else if (ageDays < 30)
    label = `${Math.max(1, Math.floor(ageDays / 7))} هفته پیش`;
  else if (ageDays < 365) label = `${Math.floor(ageDays / 30)} ماه پیش`;
  else label = `${Math.floor(ageDays / 365)} سال پیش`;

  return {
    show: true,
    label,
    color: 'secondary',
    compact: true,
    tooltip: LAST_MODIFIED_TOOLTIP
  };
};

export function referringPageBadges(data) {
  return [
    {
      show: isFlagOn(data?.is_best_link),
      label: 'بهترین',
      color: 'primary',
      icon: 'crown',
      tooltip: BEST_LINK_TOOLTIP
    },
    {
      show: isFlagOn(data?.url_from_is_home_page),
      label: 'از خانه',
      color: 'primary',
      icon: 'home',
      tooltip: HOME_PAGE_TOOLTIP
    },
    {
      show: isFlagOn(data?.is_lost),
      label: 'حذف لینک',
      color: 'danger',
      icon: 'ban',
      tooltip:
        'نشانی مقصد پیوند (href) در صفحه ارجاع‌دهنده (محل قرارگیری لینک) پیدا نشد؛ یا این صفحه وضعیت ۴۰۴ یا ۴۱۰ داشته است.'
    },
    {
      show: isFlagOn(data?.product_is_new),
      label: 'جدید',
      color: 'success',
      tooltip: NEW_LINK_TOOLTIP
    },
    getPageLanguageBadge(data),
    getPageStatusBadge(data),
    getLastModifiedBadge(data),
    {
      show: isFlagOn(data?.robots_is_noindex),
      label: 'نوایندکس',
      color: 'danger',
      tooltip: NOINDEX_TOOLTIP
    },
    {
      show: isFlagOn(data?.canonical_is_different),
      label: 'کنونیکال به غیر',
      color: 'danger',
      tooltip: CANONICAL_DIFFERENT_TOOLTIP
    },
    backlinkSpamScoreBadge(data),
    mozSpamScoreBadge(data)
  ];
}

export function linkUrlBadges(data) {
  const attrs = attributeList(data?.attributes);
  const isSponsored =
    attrs.includes('sponsored') || attrs.includes('sponsered');
  const semanticLocation =
    typeof data?.semantic_location === 'string'
      ? data.semantic_location.trim().toLowerCase()
      : '';

  return [
    {
      show: !isFlagOn(data?.dofollow),
      label: 'نوفالو',
      color: 'warning',
      tooltip: 'این لینک rel=nofollow دارد یا مقدار dofollow آن false است.'
    },
    {
      show: isFlagOn(data?.is_external),
      label: 'EXT',
      color: 'secondary',
      compact: true,
      tooltip:
        'این لینک با rel=external مشخص شده و به دامنه‌ای خارج از دامنه سایت شما اشاره می‌کند.'
    },
    {
      show: isFlagOn(data?.is_ugc),
      label: 'UGC',
      color: 'secondary',
      compact: true,
      tooltip: 'این لینک با rel=ugc علامت‌گذاری شده است.'
    },
    {
      show: isSponsored,
      label: 'SP',
      color: 'secondary',
      compact: true,
      tooltip: 'این لینک با rel=sponsored علامت‌گذاری شده است.'
    },
    {
      show: isFlagOn(data?.is_alternate),
      label: 'ALT',
      color: 'secondary',
      compact: true,
      tooltip:
        'این لینک با rel=alternate علامت‌گذاری شده و به نسخه جایگزین محتوا اشاره می‌کند.'
    },
    {
      show: isFlagOn(data?.is_noopener),
      label: 'NOP',
      color: 'secondary',
      compact: true,
      tooltip:
        'این لینک rel=noopener دارد؛ صفحه مقصد به پنجره بازکننده دسترسی ندارد.'
    },
    {
      show: isFlagOn(data?.is_noreferrer),
      label: 'NRE',
      color: 'secondary',
      compact: true,
      tooltip:
        'این لینک rel=noreferrer دارد؛ اطلاعات ارجاع‌دهنده ارسال نمی‌شود.'
    },
    {
      show: Boolean(semanticLocation),
      label: `SE: ${semanticLocation}`,
      color: 'secondary',
      compact: true,
      tooltip: SEMANTIC_LOCATION_TOOLTIP
    },
    {
      show: isFlagOn(data?.in_text),
      label: 'در متن',
      color: 'success',
      tooltip:
        'در اطراف لینک شما متن وجود دارد و این موضوع ارزش لینک را بالاتر می‌برد.'
    },
    {
      show: String(data?.item_type || '').toLowerCase() === 'image',
      label: 'تصویر',
      color: 'success',
      tooltip: 'این بک‌لینک از نوع تصویر است.'
    },
    {
      show: isFlagOn(data?.is_broken),
      label: 'شکسته',
      color: 'danger',
      tooltip:
        'مقصد لینک (href) هنگام بررسی توسط میزفا تولز با خطای ۴xx یا ۵xx مواجه بوده است.'
    }
  ];
}
